import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form as FormikForm } from 'formik'
import { Modal, ModalHeader, ModalSubHeader, ModalContent } from '../index'
import { Button } from '../../Button'
import SectionSelect from '../../Form/SectionSelect'
import './configureScenarioModal.scss'

const defaultBlocks = [
  { label: "Assets", name: "assets" },
  { label: "Cashflow events", name: "cashflow_events" },
  { label: "Capital chart", name: "capital_chart" },
  { label: "Income chart", name: "income_chart" },
  { label: "Details", name: "details" },
  { label: "Risk profile", name: "risk_profile" },
  { label: "Risk products", name: "risk_products" },
  { label: "Liabilities", name: "liabilities" },
  { label: "Asset allocation", name: "asset_allocation" },
  { label: "Financial needs analysis", name: "financial_needs_analysis" },
]
const optionalBlocks = [
  { label: "Notes", name: "notes" },
]

const baseClass = 'configure-scenario-modal'

const ConfigureScenarioModal = ({
  open,
  onClose,
  onCreateNewScenario
}) => {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(false)

  const onSubmit = async (values) => {
    const optional_sections = Object.entries(values).map(([key, value]) => value ? key : undefined).filter(section => Boolean(section))

    try {
      setSubmitting(true)
      await onCreateNewScenario(optional_sections)
      setSubmitting(false)
    } catch {
      setSubmitting(false)
      setError(true)
    }
  }

  const handleClose = () => {
    setError(false)
    onClose()
  }

  const prefillBlocks = (blockArray, value) => blockArray.reduce((acc, block) => ({
    ...acc,
    [block.name]: value
  }), {})

  return (
    <Modal open={open} onClose={handleClose} onEscapeKeyDown={handleClose} error={error}>
      <ModalHeader>Configure New Scenario</ModalHeader>
      <ModalSubHeader>Select the sections that you would like to copy.</ModalSubHeader>
      <ModalContent>
        <Formik
          initialValues={{
            ...prefillBlocks(defaultBlocks, true),
            ...prefillBlocks(optionalBlocks, true),
          }}
          onSubmit={(values) => onSubmit(values)}
        >
          {(props) => (
            <FormikForm className={`app-form ${baseClass}`}>
              <div className={`${baseClass}__download-section`}>

                <SectionSelect
                  sections={[
                    {
                      title: "Default sections",
                      description: "These are included in the new scenario by default.",
                      items: defaultBlocks,
                      canToggle: false
                    },
                    {
                      title: "Optional sections",
                      description: "Select additional sections that you would like to copy across.",
                      items: optionalBlocks
                    }
                  ]}
                />

                <div className={`${baseClass}__flex-container`}>
                  <div className={`${baseClass}__selection-actions`}>
                    <a onClick={(e) => {
                      e.preventDefault();
                      props.setValues(prefillBlocks(optionalBlocks, false));
                    }}>Clear all</a>
                    <a onClick={(e) => {
                      e.preventDefault();
                      props.setValues(prefillBlocks(optionalBlocks, true));
                    }}>Select all</a>
                  </div>
                </div>
              </div>

              <div className={`${baseClass}__actions`}>
                <Button secondary fullWidth onClick={handleClose} disabled={submitting}>
                  Cancel
                </Button>
                <Button type="submit" fullWidth primary disabled={submitting}>
                  {submitting ? 'Setting up scenario...' : 'Create'}
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  )
}

ConfigureScenarioModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateNewScenario: PropTypes.func.isRequired,
}

export default ConfigureScenarioModal
